import React from 'react';
import './Projects.css';
import Navbar from './Navbar';
import { FaLaptopCode, FaBook, FaUserGraduate, FaShoppingCart, FaChartLine, FaDatabase } from 'react-icons/fa';

function Projects() {
  return (
    <div>
      <Navbar />
      <div className="projects-container">
        <div className="project-item">
          <div className="project-icon">
            <FaLaptopCode />
          </div>
          <div className="project-details">
            <h2>Pnuemonia classification using Convolutional Neural Networks</h2>
            <p>Classifying pneumonia using Deep learning techniques like Convolutional Neural Networks</p>
          </div>
        </div>
        <div className="project-item">
          <div className="project-icon">
            <FaBook />
          </div>
          <div className="project-details">
            <h2>Ramayana Ebook (React Native)</h2>
            <p>Creating an eBook app for the epic Ramayana using React Native.</p>
          </div>
        </div>
        <div className="project-item">
          <div className="project-icon">
            <FaChartLine />
          </div>
          <div className="project-details">
            <h2>Age-Gender-and-Ethnicity-Detection-Using-CNN</h2>
            <p>I employ Convolutional Neural Networks (CNNs) to discern age, gender, and ethnicity from facial images, contributing to demographic analysis.</p>
          </div>
        </div>
        <div className="project-item">
          <div className="project-icon">
            <FaUserGraduate />
          </div>
          <div className="project-details">
            <h2>College Portfolio</h2>
            <p>Crafted an engaging 'College Portfolio' website using web development and JavaScript to showcase my professional achievements and skills.</p>
          </div>
        </div>
        <div className="project-item">
          <div className="project-icon">
            <FaChartLine />
          </div>
          <div className="project-details">
            <h2>Student Grade prediction</h2>
            <p>Engineered a 'Student Grade Prediction' project leveraging linear regression in machine learning to predict performance outcomes.</p>
          </div>
        </div>
        <div className="project-item">
          <div className="project-icon">
            <FaShoppingCart />
          </div>
          <div className="project-details">
            <h2>E-Commerce web application</h2>
            <p>I've crafted a user-centric e-commerce web application using web development, providing a seamless platform for product browsing and shopping.</p>
          </div>
        </div>
        <div className="project-item">
          <div className="project-icon">
            <FaDatabase />
          </div>
          <div className="project-details">
            <h2>Student Management System using Java Swing and MySQL</h2>
            <p>Engineered an efficient Student Management System using Java Spring and MySQL, streamlining administrative tasks and enhancing data management.</p>
          </div>
        </div>
        <div className="project-item">
          <div className="project-icon">
            <FaDatabase />
          </div>
          <div className="project-details">
            <h2>Java Swing & MySQL Bank Management System</h2>
            <p>BankXpress: Java Swing and MySQL-Powered Bank Management System Enabling Seamless User Registration, Login, Funds Transactions, and Balance Inquiries.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
